var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0 16px 0 16px"}},[_c('v-breadcrumbs',{attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"href":item.href,"disabled":item.disabled}},[_vm._v("\n        "+_vm._s(item.text.toUpperCase())+"\n      ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }